import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { register, load, getInstances } from '@shopify/theme-sections';
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'password-template';

Avatar.theme.sections.Password = function Password() {
  var selectors = {
    openPassword: '[data-login-open]',
    passwordField: '[data-password-field]',
    cancelPassword: '[data-login-cancel]',
    newsletterContent: '[data-newsletter]',
    passwordEntryContent: '[data-password-entry]'
  };
  var classes = {
    hidden: 'tw-hidden'
  };
  var data = {
    formError: 'data-error'
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this.container;
                _this.passwordField = container.querySelector(selectors.passwordField);
                _this.openPasswordLink = container.querySelector(selectors.openPassword);
                _this.cancelPasswordLink = container.querySelector(selectors.cancelPassword);
                _this.newsletterContainer = container.querySelector(selectors.newsletterContent);
                _this.passwordEntryContainer = container.querySelector(selectors.passwordEntryContent);

                if (_this.passwordField.hasAttribute(data.formError)) {
                  _this.togglePasswordOverlay();
                }

                _this.addEventListener();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addEventListener: function addEventListener() {
      this.openPasswordLink.addEventListener('click', this.togglePasswordOverlay.bind(this));
      this.cancelPasswordLink.addEventListener('click', this.togglePasswordOverlay.bind(this));
    },
    togglePasswordOverlay: function togglePasswordOverlay() {
      this.openPasswordLink.classList.toggle(classes.hidden);
      this.cancelPasswordLink.classList.toggle(classes.hidden);
      this.newsletterContainer.classList.toggle(classes.hidden);
      this.passwordEntryContainer.classList.toggle(classes.hidden);
    }
  });
  load(sectionName);
  var instance = getInstances(sectionName);
  return instance[0];
}();